import { Injectable } from '@angular/core';
import {UtilsService} from './utils.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RestService {

    urlApi: any = environment;
    userToken: string;

  constructor(private httpClient: HttpClient, private utilsService: UtilsService) { }

    /**************  GET  **************/
    public get(endPoint: string){
        this.userToken = this.utilsService.getStorage('token');
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                Authorization: this.userToken
            })
        };
        return this.httpClient.get( endPoint, httpOptions);
    }
    public getPeriods(endPoint: string){
        this.userToken = this.utilsService.getStorage('token');
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                Authorization: this.userToken,
                'x-api-key': '3Zd7p4dBe3v0sdbkjhrQaaeIaEhX17Ks2qSnVvjVxH8h'
            })
        };
        return this.httpClient.get( endPoint, httpOptions);
    }
    public getNoToken(endPoint: string){
        this.userToken = this.utilsService.getStorage('token');
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
            })
        };
        return this.httpClient.get( endPoint, httpOptions);
    }

    /**************  POST  **************/
    public post(endPoint: string, params?: Object){
        this.userToken = this.utilsService.getStorage('token');
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                Authorization: 'Bearer ' + this.userToken
            })
        };
        //return this.httpClient.post( this.urlApi.urlBase + endPoint , params, httpOptions );
        return this.httpClient.post( endPoint , params, httpOptions );
    }
    public postUsers(endPoint: string, params?: Object){
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                'userPool': 'us-west-2_IbqipYRsF',
                'x-api-key': 'txNnLqPfwQ3ViJ5ZBQfw56RcZ4nc69IIenfpODpedwU='
            })
        };
        //return this.httpClient.post( this.urlApi.urlBase + endPoint , params, httpOptions );
        return this.httpClient.post( endPoint , params, httpOptions );
    }
    public postShortUrl(endPoint: string, params?: Object){
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                'x-api-key': this.urlApi.keyUrlShorPath
            })
        };
        return this.httpClient.post( endPoint , params, httpOptions );
    }
    public postImg(endPoint: string, params?: Object){
        this.userToken = this.utilsService.getStorage('token');
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                'x-api-key': this.urlApi.keySaveImage
            }),
            'responseType': 'text'
        };
        //return this.httpClient.post( this.urlApi.urlBase + endPoint , params, httpOptions );
        return this.httpClient.post( endPoint , params, httpOptions );
    }
    public postExcel(endPoint: string, params?: Object){
        this.userToken = this.utilsService.getStorage('token');
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                Authorization: this.userToken
            }),
            responseType: 'text'
        };
        return this.httpClient.post( endPoint , params, httpOptions );
        //return this.httpClient.post( this.urlApi.urlBase + endPoint , params, httpOptions );
    }

    /**************  PUT  **************/
    public put(endPoint: string, params?: Object){
        this.userToken = this.utilsService.getStorage('token');
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                Authorization: this.userToken
            })
        };
        return this.httpClient.put( endPoint , params, httpOptions );
        //return this.httpClient.put( this.urlApi.urlBase + endPoint , params, httpOptions );
    }

    /**************  PATCH  **************/
    public patch(endPoint: string, params?: Object){
        this.userToken = this.utilsService.getStorage('token');
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                Authorization: this.userToken
            })
        };
        return this.httpClient.patch( endPoint , params, httpOptions );
        //return this.httpClient.put( this.urlApi.urlBase + endPoint , params, httpOptions );
    }

    /**************  DELETE  **************/
    public delete(endPoint: string, params?: Object){
        this.userToken = this.utilsService.getStorage('token');
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                Authorization: this.userToken
            }),
            body: params
        };
        return this.httpClient.delete( endPoint , httpOptions );
        //return this.httpClient.delete( this.urlApi.urlBase + endPoint , httpOptions );
    }

    /*** Servicios rest para reportería  ***/
    public getReports(endPoint: string){
        this.userToken = this.utilsService.getStorage('token');
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                'Authorization': 'Basic aXZhZ291c2VyOnhqQjZOJDdK'
            })
        };
        return this.httpClient.get(endPoint , httpOptions );
    }

    public postReports(endPoint: string, params?: Object){
        this.userToken = this.utilsService.getStorage('token');
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                'Authorization': 'Basic aXZhZ291c2VyOnhqQjZOJDdK'
            })
        };
        return this.httpClient.post(endPoint , params, httpOptions );
    }

    public postSalesSummary(endPoint: string, params?: Object){
        this.userToken = this.utilsService.getStorage('token');
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                'x-api-key': 'LFXKKLpCXVADdjDGp2CtjP0yRYFOu1f05aLejTpRbYc4'
            }),
            'responseType': 'text'
        };
        //return this.httpClient.post( this.urlApi.urlBase + endPoint , params, httpOptions );
        return this.httpClient.post( endPoint , params, httpOptions );
    }

    /*********** REST DEMOS ***********/
    public postDemos(endPoint: string, params?: Object){
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                'x-api-key': this.urlApi.keyDemos
            }),
            'responseType': 'text'
        };
        return this.httpClient.post( endPoint , params, httpOptions );
    }
    public putDemos(endPoint: string, params?: Object){
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                'x-api-key': this.urlApi.keyDemos
            }),
            'responseType': 'text'
        };
        return this.httpClient.put( endPoint , params, httpOptions );
    }
    public getDemos(endPoint: string){
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                'x-api-key': this.urlApi.keyDemos
            })
        };
        return this.httpClient.get( endPoint, httpOptions);
    }
    public getMotivos(endPoint: string){
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                'x-api-key': this.urlApi.keyMotivos
            })
        };
        return this.httpClient.get( endPoint, httpOptions);
    }
    public putMotivos(endPoint: string, params?: Object){
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                'x-api-key': this.urlApi.keyMotivos
            }),
            'responseType': 'text'
        };
        return this.httpClient.put( endPoint , params, httpOptions );
    }

    /*********** REST Catalogo de movimientos ***********/
    public getMovementsCatalog(endPoint: string){
        this.userToken = this.utilsService.getStorage('token');
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                Authorization: this.userToken,
                'x-api-key': 'ltMtmXZDs5hf9v4Tf2TL7WNZ5ouUSzIm9AUctdFkVC'
            })
        };
        return this.httpClient.get( endPoint, httpOptions);
    }
    public putMovementsCatalog(endPoint: string, params?: Object){
        const httpOptions: any = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                Authorization: this.userToken,
                'x-api-key': 'ltMtmXZDs5hf9v4Tf2TL7WNZ5ouUSzIm9AUctdFkVC'
            })
        };
        return this.httpClient.put( endPoint , params, httpOptions );
    }
}
